import * as e from "@ant-design/icons-vue";
const {
  // 搜索相关
  SearchOutlined: t,
  // 用户相关
  UserOutlined: n,
  // 设置相关
  SettingOutlined: i,
  DatabaseOutlined: d,
  FileTextOutlined: l,
  // 机器人/AI相关
  RobotOutlined: u,
  QuestionCircleOutlined: O,
  // 消息相关
  SendOutlined: o,
  AudioOutlined: r,
  PaperClipOutlined: a,
  PauseOutlined: s,
  PictureOutlined: p,
  // 布局相关
  AppstoreOutlined: c,
  UnorderedListOutlined: f,
  MenuFoldOutlined: m,
  MenuUnfoldOutlined: A,
  // 导航相关
  DownOutlined: P,
  ArrowLeftOutlined: b,
  // 操作相关
  PlusOutlined: x,
  LogoutOutlined: C,
  MoreOutlined: L,
  // 内容类型相关
  GlobalOutlined: M,
  VideoCameraOutlined: S,
  EnvironmentOutlined: U
} = e;
export {
  c as AppstoreOutlined,
  b as ArrowLeftOutlined,
  r as AudioOutlined,
  d as DatabaseOutlined,
  P as DownOutlined,
  U as EnvironmentOutlined,
  l as FileTextOutlined,
  M as GlobalOutlined,
  C as LogoutOutlined,
  m as MenuFoldOutlined,
  A as MenuUnfoldOutlined,
  L as MoreOutlined,
  a as PaperClipOutlined,
  s as PauseOutlined,
  p as PictureOutlined,
  x as PlusOutlined,
  O as QuestionCircleOutlined,
  u as RobotOutlined,
  t as SearchOutlined,
  o as SendOutlined,
  i as SettingOutlined,
  f as UnorderedListOutlined,
  n as UserOutlined,
  S as VideoCameraOutlined,
  e as default
};
